function resourcePaginationLink(data = {}) {
  var { removeSectionWrapper } = Alpine.store('utilities');

  return {
    ...data,

    isLoading: false,

    onClick() {
      if (this.isLoading) return;

      this.isLoading = true;

      this.$dispatch('resourcepaginationlinkclickstart');

      var url =  new URL(this.$el.href);

      url.hash = '';

      var sectionUrl = new URL(url);

      sectionUrl.searchParams.set('section_id', this.sectionId);

      fetch(sectionUrl)
        .then((res) => {
          if (!res.ok) {
            throw new Error();
          }

          return res.text();
        })
        .then((res) => {
          var sectionHtml = removeSectionWrapper(res);

          this.$dispatch('resourcepaginationlinkclicksuccess', { url, sectionHtml });
        })
        .catch((err) => {
          this.$dispatch('resourcepaginationlinkclickerror');
        })
        .finally(() => {
          this.isLoading = false;
          this.$dispatch('resourcepaginationlinkclickend');
        });
    }
  };
};

document.addEventListener('alpine:init', () => {
  Alpine.data('resourcePaginationLink', resourcePaginationLink);
});
